import React from "react";

class Video extends React.Component {
  render() {
    return (
      <section id="video">
        <div className="container">
          <div className="col-md-12">
            <div className="title-block">
              <h2>Coding is for Everyone</h2>
            </div>
            <div className="video-wrapper">
              <iframe title="Video" className="video" src="https://www.youtube.com/embed/Xemei9cLBe4" frameBorder="0" allow="fullscreen"></iframe>
            </div>
            <p style={{marginTop: "20px"}}>The video “Coding is for Everyone” showcases four individual profiles coming from different background but having the same interest - coding. The video was screened during the NDSC Opening Ceremony on 23 February 2019. </p>
          </div>
        </div>
      </section>
    );
  }

}

export default Video;